import { graphql } from '../../../graphql/generated';

export const SAVE_USER_ASSIGNMENT_MUTATION = graphql(`
  mutation SaveUserAssignment($input: UserAssignmentInput!) {
    saveUserAssignment(input: $input) {
      id
    }
  }
`);
